@if (progress) {
<div class="app-loading-overlay">
  <cds-progress class="col-xs-12" mode="indeterminate" type="ring" [diameter]="60"></cds-progress>
</div>
} @if (!progress && cols && cols.length > 0) { @if (!noTopLine) {
<div class="row">
  <div class="col-xs-12 top-line"></div>
</div>
}
<ng-content></ng-content>
} @else {
<div class="row">
  <div class="col-xs-12">
    <app-no-result-found></app-no-result-found>
  </div>
</div>
}
